<template>
  <div ref="contentRef" class="markdown-body" v-html="html"></div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { marked } from "marked";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";

const props = defineProps({
  source: String,
});

const contentRef = ref(null);
const html = ref("");

function render() {
  let str = marked(props.source || "")
  if (str.includes("<table>")) {
    html.value = str.split("<table>").join("<div class='tableBox'><table>").split("</table>").join("</table></div>")
  } else {
    html.value = str
  }
}

onMounted(render);
watch(() => props.source, render);

onMounted(() => {
  // 代码高亮
  setTimeout(() => {
    contentRef.value.querySelectorAll("pre code").forEach((block) => {
      hljs.highlightElement(block);
    });
  });
});
</script>

<style lang="scss">
.markdown-body {
  line-height: 1.75;
}

.markdown-body hr {
  margin: 16px 0;
}

.markdown-body img {
  max-width: 100%;
}

.markdown-body * {
  font-size: 14px;
  color: #333333;
}

.markdown-body .tableBox {

  max-width: 100%;
  margin: 16px 0;

  table {
    max-width: 100%;
    background: #EFF5FF;
  }
}

.markdown-body .tableBox table thead {
  border-top: 1px solid #A0BBE8;
  border-left: 1px solid #A0BBE8;
  border-right: 1px solid #A0BBE8;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.markdown-body .tableBox table tbody {
  border-bottom: 1px solid #A0BBE8;
  border-left: 1px solid #A0BBE8;
  border-right: 1px solid #A0BBE8;
  border-radius: 0 0 16px 16px;
}

.markdown-body .tableBox table th {
  background: #E2EDFF;
  font-weight: 600;
  color: #394D7B;
  border-left: 1px solid #A0BBE8;
  padding: 4px 14px;
}

.markdown-body .tableBox table th:first-child {
  border-left: none;
}

.markdown-body .tableBox table tr td {
  border-top: 1px solid #A0BBE8;
  border-left: 1px solid #A0BBE8;
  padding: 4px 14px;
}

.markdown-body .tableBox table tr td:first-child {
  border-left: none;
}
</style>
